<script lang="ts">
  import { observe } from "$lib/actions/observe";
  import SEOSEA from "$lib/images/seo_sea.jpg?enhanced";
  import WEBDEVELOPMENT from "$lib/images/webdevelopment.jpg?enhanced";
  import UXUI from "$lib/images/ux3.png?enhanced";
  import JAMSTACK from "$lib/images/JAMSTACK.png?enhanced";
  import ECOMMERCE from "$lib/images/shop.png?enhanced";
  import WEBMANAGEMENT from "$lib/images/webmanagement.jpg?enhanced";

  const ImageSources: Record<string, typeof SEOSEA> = {
    seo: SEOSEA,
    webdevelopment: WEBDEVELOPMENT,
    uxui: UXUI,
    jamstack: JAMSTACK,
    ecommerce: ECOMMERCE,
    webmanagement: WEBMANAGEMENT
  };

  let {
    services = [] as Array<{
      anchor?: string;
      number: string;
      title: string;
      details: string[];
      imagePlaceholder: string;
      imageSource: string;
      imageReversed?: boolean;
    }>
  } = $props();
</script>

<section>
  <div class="container">
    {#each services as service, i}
      <div id={service.anchor} class="service-detail-grid fade-up" use:observe style={i > 0 ? "margin-top:4rem" : ""}>
        <div style={service.imageReversed ? "order:2" : ""}>
          <span class="section-label">{service.number}</span>
          <h2>{service.title}</h2>
          <ul style="list-style:disc;padding-left:1.25rem;margin-top:1rem">
            {#each service.details as detail}
              <li style="margin-bottom:0.5rem;color:var(--muted);font-size:0.95rem">{detail}</li>
            {/each}
          </ul>
        </div>
        <div style={service.imageReversed ? "order:1" : ""}>
          <div class="card-thumb" style="aspect-ratio:4/3;background:var(--border);border-radius:var(--radius-md);display:flex;align-items:center;justify-content:center;color:var(--muted);font-size:0.85rem">
            <enhanced:img src={ImageSources[service.imageSource]} alt={service.title} />
          </div>
        </div>
      </div>
    {/each}
  </div>
</section>
